<template>
  <OurPage
    data-cy="users-page"
    :title="$t('title.dealershipApplications._')"
    :description="isAnalyticsTab ? $t('title.dealershipApplications.description') : undefined"
    gray
    class="users-page"
  >
    <FilterModal
      :key="$route.name"
      :is-applications="isApplicationsTab"
      :show.sync="isShownFilterModal"
    />

    <div class="header-block">
      <div class="flex gap-8">
        <router-link
          v-for="tab in tabs"
          :key="tab.routeName"
          :class="{
            'underline decoration-[2px] underline-offset-[10px]': $route.name === tab.routeName,
          }"
          :to="{ name: tab.routeName }"
        >
          {{ $t(tab.labelKey) }}
        </router-link>
      </div>

      <div class="buttons">
        <div v-if="getPermission['customer.notifications']">
          <OurButton
            v-if="!isMobileDevice"
            :text="$t('title.fleaMarket.settingsModal')"
            @click="onClickSettingsButton"
          />
          <OurButton v-else @click="onClickSettingsButton">
            <OurSvgIcon
              class="settings-icon"
              :src="icons.Settings"
              color="white"
              variant="light"
              size="md"
            />
          </OurButton>
        </div>
        <OurButton
          variant="thirdary"
          filled
          :text="$t('button.filters')"
          @click="onClickFilterButton"
        >
          <OurSvgIcon v-if="isMobileDevice" :src="icons.FilterAltFill" />
        </OurButton>
      </div>
    </div>

    <router-view />

    <SettingsModal :show.sync="isShownSettingsModal" />
  </OurPage>
</template>

<script>
import { mapGetters } from "vuex";
import FilterModal from "../filter/Modal";
import SettingsModal from "@/views/settings/dealership-applications/settings/Modal.vue";

export default {
  name: "DealershipApplications",

  components: { FilterModal, SettingsModal },

  data() {
    return {
      isShownFilterModal: false,
      isShownSettingsModal: false,
    };
  },

  computed: {
    ...mapGetters("breakpoint", ["isMobileDevice"]),
    ...mapGetters("user", ["getPermission"]),

    icons: () => ({
      Settings: require("@material-symbols/svg-400/outlined/settings.svg"),
      FilterAltFill: require("@material-symbols/svg-400/outlined/filter_alt-fill.svg"),
    }),

    tabs() {
      return [
        {
          routeName: "DealershipApplications",
          labelKey: "title.applications",
          isApplications: true,
        },
        ...(this.getPermission?.["customer.applications_analytics"]
          ? [
              {
                routeName: "DealershipApplicationsAnalytics",
                labelKey: "title.dealershipApplications.analytics",
                isAnalytics: true,
              },
            ]
          : []),
      ];
    },

    isApplicationsTab() {
      const currentTab = this.tabs.find((tab) => tab.routeName === this.$route.name);

      return Boolean(currentTab?.isApplications);
    },

    isAnalyticsTab() {
      const currentTab = this.tabs.find((tab) => tab.routeName === this.$route.name);

      return Boolean(currentTab?.isAnalytics);
    },
  },

  methods: {
    onClickSettingsButton() {
      this.isShownSettingsModal = true;
    },

    onClickFilterButton() {
      this.isShownFilterModal = true;
    },
  },
};
</script>

<style lang="postcss" scoped>
.users-page {
  .header-block {
    @apply mb-6 flex flex-col items-start justify-between space-y-4 md:flex-row md:items-end md:space-y-0;

    .buttons {
      @apply flex h-[2.625rem] w-full flex-row-reverse items-center justify-between gap-4 sm:flex-row sm:justify-end;
    }
  }
}
</style>
